<template>
  <div class="manager-container module-main-body"  v-loading="fullScreenLoading">
    <el-row class="module-content-top-bar">
      <el-col :md="24" :lg="10">
        <h1 class="top-bar-title">{{contentTitle}}</h1>
      </el-col>
      <el-col :md="24" :lg="14">
        <div class="button-bar ">
          <el-button @click="toggleAllCheckboxes">{{ allChecked ? 'Uncheck All' : 'Check All' }}</el-button>
          <span
            class="primary-button"
            @click="handleSaveToList">
            Save
          </span>
        </div>
      </el-col>
    </el-row>
    <el-row class="div-main-body-left-right module-content-main-view" v-if="!fullScreenLoading">
      <el-col  :sm="hasSysAdminPermission ? 10 : 0" :md="hasSysAdminPermission ? 8 : 0" :lg="hasSysAdminPermission ? 5 : 0" class="left">
        <div class="title">
          <base-block-title
            :title="$t('company')"
            :sub-title="companyList.length">
          </base-block-title>
        </div>
        <el-divider class="el-divider"></el-divider>
        <div class="search-bar">
          <el-input
            class="round-input"
            placeholder="Search Company Name"
            v-model="searchKey"
            @keypress.enter.native="onHandleSearch"
          >
            <el-button v-if="!toggleIcon" type="primary" slot="append" icon="el-icon-search" @click="onHandleSearch"></el-button>
            <el-button v-if="toggleIcon" type="primary" slot="append" icon="el-icon-close" @click="onHandlClearSearch"></el-button>
          </el-input>
        </div>
        <div class="content">
          <company-item-new
            v-for="item in companyList"
            :key="item.id"
            :company="item"
            :currentCompany="currentCompany"
            :logoSrc.sync="item.logoSrc"
            :showStatusTage="true"
            :active="item.id === currentCompany.id"
            @click.native="handleCompanyClick(item)">
          </company-item-new>
        </div>
      </el-col>
      <el-col :sm="hasSysAdminPermission ? 14 : 24" :md="hasSysAdminPermission ? 16 : 24" :lg="hasSysAdminPermission ? 19 : 24"
        class="right"
        v-if="pageVisible && currentCompany.id">
          <el-table 
            :data="productList" 
            style="width: 100%"
            border
            table-layout="fixed" 
            :header-cell-style="HEADER_CELL_STYLE"
            :cell-style="CELL_STYLE"
            row-key="id"
            key="tableKey"
            ref="productListRef"
          >
            <el-table-column label="No." width="50">
              <template #default="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="productName" label="Product Name" />
            <!-- <el-table-column v-if="isMar"prop="customerProductName" label="Customer Product Name" /> -->
            <el-table-column
              v-if="isMaersk"
              prop="customerProductName"
              label="Customer Product Name"
              style="width: 100%;height: 28px;"
              size="mini"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.customerProductName"
                  size="mini"
                  placeholder="Enter name"
                />
              </template>
            </el-table-column>

            <el-table-column label="Add to List">
              <template slot-scope="scope">
                <el-checkbox 
                  style="padding-right: 100%;"
                  v-model="scope.row.flag" 
                  false-label="0" 
                  true-label="1">
                </el-checkbox>

              </template>
            </el-table-column>
          </el-table>
          <base-no-data v-if="!currentCompany.id"></base-no-data>
      </el-col>
    </el-row>


  </div>
</template>

<script>
import { mapState } from 'vuex'
import baseMixin from '@/mixins/base-mixin'
import baseTableMixin from '@/mixins/base-table-mixin'
import { isValidString } from '@/utils/index.js'
import { getCompanyList,getCompanyProductsList, addCompanyProductsList } from "@/services/modules";
import { HEADER_CELL_STYLE, CELL_STYLE } from "@/constants.js";
export default {
  name: 'ProductManager',
  mixins: [baseMixin, baseTableMixin],
  components: {  },
  data () {
    return {
      HEADER_CELL_STYLE,
      CELL_STYLE,
      contentTitle: 'Product Management',
      companyList: [],
      currentCompany: {},
      users: [],
      pageVisible: true,
      searchKey: null,
      toggleIcon: false,
      fullScreenLoading: false,
      // productList: this.$store.state.productList,
      productList: [],
      addToProductList: [],
      tableKey: 0,
      checkAll: false,
      isMaersk: false,
    }
  },

  computed: {
    ...mapState(['roles', 'permissions',]),
    hasSysAdminPermission () {
      return this.permissions.hasSysAdminPermission
    },
    allChecked() {
      return this.productList.every(product => product.flag === '1');
    },
  },

  created () {
    this.getCompanies()    
    // this.getProductList()
  },
  methods: {
    isValidString,
    handleCompanyClick(item){
      this.currentCompany = item;
      this.getProductList()
    },
    getProductList(){
      const companyId = this.currentCompany?.id || this.$store.state.currentCompanySettings?.sysOrganizationId || null;
      if(!companyId){
        this.productList = []
        return
      }
 
      const companyName = this.currentCompany?.companyName || this.$store.state.currentCompany?.companyName || null;
      this.isMaersk = companyName == "Maersk Oil Trading Singapore Pte. Ltd."

      getCompanyProductsList(companyId).then(res => {
        if(res.data){
          this.productList = res.data.sort((a, b) =>
            a.productName.localeCompare(b.productName, undefined, { sensitivity: 'base' })
          );
          this.$store.commit("setProductListDefault", res.data);

        }else{
          this.productList = []
        }
        this.tableKey++;
      })
    },
    handleAddToList(row, val){
      row.flag = row.flag === '1' ? '0' : '1';
    },
    handleSaveToList(){
      const companyId = this.currentCompany?.id || this.$store.state.currentCompanySettings?.sysOrganizationId || null;
      const companyUen = this.currentCompany?.businessIncorporationNumber || this.$store.state.currentCompany.businessIncorporationNumber || null;

      const selectedList = this.productList
      .filter(p => p.flag === '1')
      .map(p => ({
        productId: p.productId,
        companyUenNumber: companyUen,
        companyId: companyId,
        customerProductName: p.customerProductName?? null,
      }));
 
      addCompanyProductsList(selectedList).then(res => {
        if(res.code === 1000){
          this.$message.success(this.$t('saveSuccess'))
          this.getProductList()
        }
      })
    },
    toggleAllCheckboxes() {
      const newFlagValue = this.allChecked ? '0' : '1';
      this.productList = this.productList.map(product => ({
        ...product,
        flag: newFlagValue
      }));
    },
    // getCompanyList,
    /**
     * 根据当前用户获取企业列表
     */
    getCompanies () {
      const fetchFiles = async () => {
        if(this.companyList.length <= 0) return
        this.currentCompany = this.companyList[0]
        const files = this.companyList.filter(d => d?.bdnLogo?.length > 0).map(d => d.bdnLogo[0])
        if (files.length <= 0) return
        this.downloadMultipleFileMixin(files).then(filesRes => {
          if (filesRes && filesRes !== '') {
            const logoMap = new Map(Object.entries(filesRes))
            this.companyList.forEach(company => {
              if (company?.bdnLogo?.length > 0) {
                company.logoSrc = company.bdnLogo[0].id ? logoMap.get(company.bdnLogo[0]?.id) : null
              }
            })
          }
        })
      }

      return new Promise((resolve, reject) => {
        this.fullScreenLoading = true
        if(this.hasSysAdminPermission ) {
          if (this.searchKey && this.searchKey?.trim() != '') {
            this.productList = []
            getCompanyList(this.searchKey).then(res => {
              if (res?.code === 1000) {
                this.companyList = res?.data?.records || []
                this.toggleIcon = !this.toggleIcon
                fetchFiles().then(() => {
                  this.fullScreenLoading = false
                  resolve()
                })
              }
            })
          } else {
            this.fullScreenLoading = false
            this.companyList =[]
            this.productList = []
          }     
        } else {
          const { currentCompany: globalCurrentCompany } = this.$store.state
          this.$request.get({
            url: `${this.$apis.companyBaseUrl}/${globalCurrentCompany.id}`,
          }).then(res => {
            if (res?.code === 1000) {

              this.companyList = res?.data ? [res?.data] : []

              fetchFiles().then(() => {
                this.fullScreenLoading = false
                resolve()
              })
            }
          })
          this.getProductList()
        }

      })
      
    },

    formatUser (users) {
      /**
       * 格式化排序用户列表，把当前用户排到第一位
       */
      users.forEach(item => {
        item.roles = item.roles ?? []
      })
      const { id } = this.$store.state.user
      const currentUserIndex = users.findIndex(item => item.id === id)
      if (currentUserIndex) {
        users.unshift(users[currentUserIndex])
        users.splice(currentUserIndex + 1, 1)
      }
      this.users = users
    },

    getUserListByCompany () {
      /**
       * 根据机构获取用户列表
       */
      this.$request.get({
        url: `${this.$apis.userExtBaseUrl}?pageNumber=1&pageSize=99999&organizationId=${this.currentCompany.id}`,
      }).then(res => {
        if (res?.code === 1000) {
          // 过滤角色是船的用户
          const users = (res?.data?.records || []).filter(item => {
            const roles = item.roles || []
            return !(roles.length === 1 && roles[0].code === this.$roleCode.ship)
          })
          this.formatUser(users)
        }
      })
    },
    onHandleSearch () {
      const key = this.searchKey
      if (key && key?.trim() != '') {
        this.getCompanies()
      }
    },
    onHandlClearSearch () {
      this.toggleIcon = !this.toggleIcon
      this.searchKey = ''
      this.companyList =[]
      this.currentCompany= {}
    },
  },

  watch: {
    'currentCompany.id': {
      handler (value) {
        if (value) {
          this.getUserListByCompany()
          // 重新获取当前用户的权限
          const { id: userId } = this.$store.state.user
          this.getFunctionsByUser(userId, value)
        }
      },
      immediate: true
    },
    '$route' (to) {
      const { companyId } = to.params
      this.currentCompany = this.companyList.find(item => item.id === companyId) || {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import "index";
</style>
